import { useCallback, useState } from 'react'
import { useTreasury } from 'contracts/treasury/hooks/use-treasury'
import { track } from 'shared/analytics/track'
import { useGetSmartContract } from 'shared/hooks/use-smart-contracts'
import { handleCatchAction } from 'shared/utils/handle-catch-action'
import { showNotificationToast } from 'shared/utils/notify'

export const useDepositSubmit = () => {
  const [loading, setLoading] = useState(false)
  const { smartContractAddress, smartContractVersion } =
    useGetSmartContract('Treasury')

  const treasury = useTreasury(smartContractAddress, smartContractVersion)

  const handleDeposit = useCallback(
    // eslint-disable-next-line max-statements
    async (amount: string) => {
      if (!treasury?.depositTokens) return

      setLoading(true)

      try {
        const num = Number(amount)
        if (!Number.isFinite(num) || num <= 0) {
          showNotificationToast({
            title: 'Invalid amount',
            type: 'error'
          })
          return
        }

        track('deposit_initiated', { amount: num, token: 'USDT' })
        const tx = await treasury.depositTokens(num)

        if (!tx) {
          return
        }

        showNotificationToast({
          title: `${amount} USDT deposited`,
          type: 'success'
        })
      } catch (err) {
        handleCatchAction(err)
      } finally {
        setLoading(false)
      }
    },
    [treasury]
  )

  return { handleDeposit, loading }
}
